var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72513 0.89586C2.48057 0.659655 2.15302 0.528955 1.81303 0.531909C1.47304 0.534864 1.14781 0.671237 0.907391 0.911656C0.666972 1.15208 0.530599 1.4773 0.527645 1.8173C0.52469 2.15729 0.655391 2.48484 0.891596 2.7294L7.75505 9.59285L0.891596 16.4563C0.767747 16.5759 0.668962 16.719 0.601003 16.8772C0.533044 17.0354 0.497273 17.2056 0.495776 17.3777C0.49428 17.5499 0.527089 17.7207 0.592289 17.88C0.657488 18.0394 0.753772 18.1842 0.875523 18.3059C0.997274 18.4277 1.14205 18.5239 1.30141 18.5891C1.46077 18.6543 1.63152 18.6872 1.8037 18.6857C1.97587 18.6842 2.14603 18.6484 2.30423 18.5804C2.46243 18.5125 2.60552 18.4137 2.72513 18.2898L9.58858 11.4264L16.452 18.2898C16.6966 18.526 17.0241 18.6567 17.3641 18.6538C17.7041 18.6508 18.0294 18.5145 18.2698 18.274C18.5102 18.0336 18.6466 17.7084 18.6495 17.3684C18.6525 17.0284 18.5218 16.7009 18.2856 16.4563L11.4221 9.59285L18.2856 2.7294C18.5218 2.48484 18.6525 2.15729 18.6495 1.8173C18.6466 1.4773 18.5102 1.15208 18.2698 0.911656C18.0294 0.671237 17.7041 0.534864 17.3641 0.531909C17.0241 0.528955 16.6966 0.659655 16.452 0.89586L9.58858 7.75931L2.72513 0.89586Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete Icon.c409c1be2b87a86d179029f804d19fe5.svg";
export { ForwardRef as ReactComponent };